import { createResponseSchema, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { CreateMediaRowMappingItemSchema } from '../shared/schemas/mediaRowMappings.js';

export const createMediaRowMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/media-row-mappings/' as const,
  method: 'POST',
  responseSchema: createResponseSchema(CreateMediaRowMappingItemSchema),
  processResponse(data) {
    return data;
  },
  requestSchema: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  querySchema: z.object({
    settingsId: z.string(),
    platformId: z.string(),
    platformName: z.string(),
    mediaRowId: z.string(),
  }),
  snakeCaseQueryParams: true,
});

export const deleteMediaRowMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/media-row-mappings/delete/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
  querySchema: z.object({
    settingsId: z.string(),
    platformId: z.string(),
    mediaRowId: z.string(),
    mediaRowMappingIds: z.array(z.string()),
  }),
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});
